import classNames from "classnames";
import styles from "./work-loyalty-bonus.module.scss";

interface WorkLoyaltyBonusBadgeProps {
  points: number;
  active?: boolean;
  className?: string;
}

export const WorkLoyaltyBonusBadge = ({
  points,
  active = false,
  className,
}: WorkLoyaltyBonusBadgeProps) => {
  if (points <= 0) return null;

  return (
    <span
      className={classNames(styles.badge, className, {
        [styles.active]: active,
      })}
    >
      +{points} pts
    </span>
  );
};

interface WorkLoyaltyBonusMessageProps {
  points: number;
  condition: string;
}

export const WorkLoyaltyBonusMessage = ({
  points,
  condition,
}: WorkLoyaltyBonusMessageProps) => {
  if (points <= 0) return null;

  return (
    <p className={styles.message}>
      Purchase {condition.toUpperCase()} and earn an additional{" "}
      <strong>{points} ReadingRewards Points!</strong>
    </p>
  );
};
